import { render } from "./My-Development.vue?vue&type=template&id=7289fd43&scoped=true"
import script from "./My-Development.vue?vue&type=script&lang=js"
export * from "./My-Development.vue?vue&type=script&lang=js"

import "./My-Development.vue?vue&type=style&index=0&id=7289fd43&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7289fd43"]])

export default __exports__